function alinharPrecosProdutos() {
  const titulos = document.querySelectorAll('.ecom-collection__product-item-information-title');
  const produtos = document.querySelectorAll('.ecom-collection__product-item');
  const precos = document.querySelectorAll('.ecom-collection__product-price');

  if (titulos.length === 0 || produtos.length === 0 || precos.length === 0) {
    console.warn("⛔ Elementos não encontrados para alinhamento.");
    return;
  }

  // 1. Determina a maior altura de título
  let maxHeight = 0;
  titulos.forEach(el => {
    el.style.minHeight = 'unset';
    const height = el.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // 2. Aplica altura uniforme aos títulos
  titulos.forEach(el => {
    el.style.minHeight = `${maxHeight}px`;
  });

  // 3. Garante estrutura flexível nas boxes
  produtos.forEach(el => {
    el.style.display = 'flex';
    el.style.flexDirection = 'column';
    el.style.height = '100%';
  });

  // 4. Empurra o preço para o fundo
  precos.forEach(el => {
    el.style.marginTop = 'auto';
  });

  console.log("✅ Preços alinhados com sucesso");
}

// Espera até os produtos estarem prontos no DOM
const intervalo = setInterval(() => {
  const grid = document.querySelector('.ecom-collection-product__layout-grid');
  const produtos = document.querySelectorAll('.ecom-collection__product-item');

  if (grid && produtos.length > 0) {
    clearInterval(intervalo);
    alinharPrecosProdutos();

    // Observa se novos produtos são carregados
    const observer = new MutationObserver(() => {
      alinharPrecosProdutos();
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });

    console.log("👁️ Observer ativo para grid de produtos");
  }
}, 300);
